import React from "react";
import { useTranslation } from "react-i18next";

import { competitorFilterGet } from "../../../services/api/competitor.js";
import { models } from "../../../services/enums/index.js";
import { DataPanelTemplate } from "../../shared/templates/index.js";
import { CompetitorsPanelItem } from "../index.js";

export default React.memo(({ bgFrom, initData = {} }) => {
  const { t } = useTranslation();

  return (
    <DataPanelTemplate
      filterGet={competitorFilterGet}
      dataPrefix="competitors"
      addTooltip="add_competitor"
      sortDescs={[
        { label: t("from_newest"), desc: "-createdAt" },
        { label: t("from_oldest"), desc: "createdAt" },
      ]}
      filterDescs={{
        plan: { type: "hidden", value: initData.planId },
      }}
      model={models.COMPETITOR}
      panelItem={CompetitorsPanelItem}
      bgFrom={bgFrom}
      initData={initData}
    />
  );
});
